import ApiDefault from "../../ApiDefault";

export default function ApiUnitsInventory() {
    const apiDefault = ApiDefault("v2/basics/units-inventory");

    return {
        apiDefault,
    };
}
